import React, {Component} from 'react';
import '../../style/common-style.css';
import '../../style/my-dashBoard.css';
import '../../style/font-family.css';
import '../../style/top-menubar.css';
import {connect} from 'react-redux';
import * as Constants from '../common/Constants';
import * as Tagging from '../../tagging/DashboardTagging';
import {
    GenericMenu,
    Loader
} from "@vodacombusiness/web-vb-common";

class MyDashboard extends Component {

    state = {
        showLoader: false
    }

    componentDidMount() {
        document.title = 'Dashboard';
        Tagging.dashboardPageLoad();
    };

    redirectToGsm = () => {
        this.setState({
            showLoader: true
        });
        window.location.assign(`${process.env.REACT_APP_GSM_URL}`);
    };

    redirectToFixProducts = () => {
        this.setState({
            showLoader: true
        });
        Constants.redirectToFixProducts();
    };

    render() {
        return (
            <React.Fragment>
                { this.state.showLoader && <Loader /> }
                <GenericMenu
                    parent={'dashboard'}
                    currentTab={'dashboard'}
                    pageLevel={'account'}
                    alignTop={''}>
                <div style={{display: "flex",justifyContent: "center", width:"100%", padding:"20px" }}>
                    <div className="main-content-wrapper full-width">

                        <div className="parent-main-wrapper full-width">
                            <div className="dashboard-content">
                                <label className="content-title">Hello, {this.props.firstName}</label>
                                <span className="content-sub-text">What would you like to manage today?</span>
                                <div className="option-card" onClick={this.redirectToFixProducts}>
                                    <svg focusable="false" aria-hidden="true" className="icon">
                                        <use xlink="http://www.w3.org/2000/svg"
                                             href="#icon-converged-proposition"></use>
                                    </svg>
                                    <span className="bold-title">Fixed services</span>
                                    <span className="light-title">Fibre, LTE and broadband.</span>

                                </div>
                                <div className="option-card" onClick={this.redirectToGsm}>
                                    <svg focusable="false" aria-hidden="true" className="icon">
                                        <use xlink="http://www.w3.org/2000/svg" href="#number-portability"></use>
                                    </svg>
                                    <span className="bold-title">Mobile services</span>
                                    <span className="light-title">Postpaid & hybrid cellphone contracts</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                </GenericMenu>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        firstName: state.vbContext.firstName,
        username: state.username,
        msLoginUrl: state.vbContext.msLoginUrl,
        pwd: state.vbContext.pwd
    }
};

export default connect(mapStateToProps, null)(MyDashboard);
